import { createFileRoute } from '@tanstack/react-router';
import { RequestAccessPage } from '@pages/request-access';

export const Route = createFileRoute('/request-access')({ component: RequestAccessPage });
